import { i as r, a as t, b as s } from "./isArray.CdbPONHA.js";
var a = "[object String]";
function g(i) {
  return typeof i == "string" || !t(i) && r(i) && s(i) == a;
}
export {
  g as i
};
